export default __webpack_public_path__ + "static/radial-icon-map-integration-15c2692fca384b5a7804b3cafe56d0ef.svg";